export const ROUTES = {
  ARTICLES: '/articles',
  ABOUT: '/about',
  STYLEGUIDE: '/styleguide',
  TAGS: '/tags',
  SERIES: '/series'
};
